import React, { useContext } from 'react'
import { Grid, Menu, Popup } from 'semantic-ui-react'
import { Button } from 'semantic-ui-react'
import { ConfigProps } from '../../../../../../components/financialTables/configuration/constants';
import { DescriptorProps } from '../../../../../../constnats/descriptor';
import Utils from '../../../../../../utils/descriptor/descriptorUtils';
import { TableUpdateContext } from '../../../../../../contexts/reviewTypeContext';
import { BranchTypes } from '../../../../../../constnats/schemaConstants';
import { Diff } from 'lucide-react';

class Header {
    constructor(fieldDescriptor, level) {
        this.fieldDescriptor = fieldDescriptor;
        this.level = level;
    }
}

/**
 * 
 * @param {Array} descriptors Required
 * @param {number} level Required
 * @returns {Array<Header>}
 */
function columnItems(descriptors, level) {
    const items = []
    for (const descriptor of descriptors) {
        items.push(new Header(descriptor, level))
        items.push(...columnItems(descriptor.subFields, level + 1))
    }

    return items
}


function getHeader(level, label, standardizedLabel, flipSign, signFlipEnabled) {
    const popupContent = (
        <>
            {label}
            {standardizedLabel && (
                <div>
                    <b>Standardized Label:</b> {standardizedLabel.name}
                </div>
            )}
        </>
    );
    return (
        <Popup
            size="tiny"
            content={popupContent}
            trigger={
                <div className={'flex gap-10 flex-justify-space-between tableHeaderLevel_' + level}>
                    <div className="tableHeaderLabel">{label}</div>
                    {signFlipEnabled && (
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                flipSign();
                            }}
                            className='tableActionButton'
                        >
                            <Diff size={15} strokeWidth={1} />
                        </button>
                    )}
                </div>
            }
        />
    );
}


function HeaderColumn({ descriptors, position, setHighlightedRows, highlightedRows, readOnlyMode, addReport, advancedTableCfg, standardizedLabels, flipSign }) {
    const {branchType} = useContext(TableUpdateContext);
    /**
     * @returns {string} returns the additional class names based on the advanced settings
     */
    const getAdditionalHeaderColumnClasses = () => {
        const headerFontSizeClass = `headerFontSize_${advancedTableCfg[ConfigProps.HEADER_COLUMN_FONT_SIZE]}`
        const headerWidthClass = `headerWidth_${advancedTableCfg[ConfigProps.HEADER_COLUMN_WIDTH]}`
        return `${headerFontSizeClass} ${headerWidthClass}`
    }

    const items = columnItems(descriptors, 0)
    return <Grid.Column className={`tableHeader ${getAdditionalHeaderColumnClasses()} ${position}`} textalign='left'>
        <Menu fluid vertical className={advancedTableCfg[ConfigProps.VERTICALS] ? "" : "noVerticals"}>
            <table className='header column-table'>
                <tbody>
                    {items.map((i, idx) => {
                        const standardizedLabel = standardizedLabels.find(a => a.id === i.fieldDescriptor[DescriptorProps.STANDARDIZED_LABEL_RELATION]?.standardizedLabelId)
                        return (
                            <tr
                                onMouseEnter={() => setHighlightedRows([idx + 1])}
                                onMouseLeave={() => setHighlightedRows([])}
                                key={idx}
                                className={`${advancedTableCfg[ConfigProps.HORIZONTALS] ? "horizontals" : ""} column-table-row`}
                                style={highlightedRows.includes(idx + 1) ? Object.assign({}, i.fieldDescriptor.style, { backgroundColor: "#ffff99" }) : i.fieldDescriptor.style}
                            >
                                <td>
                                    {getHeader(
                                        i.level,
                                        i.fieldDescriptor.label,
                                        standardizedLabel,
                                        () => flipSign(i.fieldDescriptor[DescriptorProps.ID]),
                                        Utils.isDynamic(i.fieldDescriptor) 
                                            && !Utils.hasCalculation(i.fieldDescriptor) 
                                            && branchType !== BranchTypes.MAIN)}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            {!readOnlyMode &&
                <Button.Group className='createReportBtn' size="mini" color='blue'>
                    <Button primary
                        size="mini"
                        onClick={() => addReport()}>Add</Button>
                </Button.Group>}
        </Menu>
    </Grid.Column>

}

export default HeaderColumn